import type { App as InstanceVueType } from 'vue';
import { setupI18n } from '@/locales';
import { setupRouter } from '@/router';
// import { setupSentry } from '@/utils/sentry';

export const initApp = async (app: InstanceVueType) => {
  // 注册国际化
  setupI18n(app);
  // 注册路由
  setupRouter(app);
  // setupSentry(app);
  // undefinedFunc();
};
